module.exports = __webpack_public_path__ + "img/hospital.385bdf58.svg";